/**
 *
 * @author arman
 * @since 9/26/17
 *
 */
import React from 'react';
import gStyles from '../../utility/styles';
import DoctorInfo from './doctor-info.component';
import PatientInfo from './patient-info.component';
import PrescriptionList from './prescription-list';
import ReportList from './report-list';
import FollowupInfo from './followup-info.component';
import MissionBasicInfo from './mission-basic-info.component';
import ReviewListView from './review-list-view.component';
import ActivityList from '../shared/activity-list.component';

const styles = {
  root: {
    backgroundColor: 'white'
  },
  box: (isDialog) => {
    let box= {
      backgroundColor: '#fff',
      border: 'none',
      borderRadius: '5px',
      position: 'relative',
      boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)'
    };

    if (!isDialog) {
      box.marginLeft = '10px';
      box.marginRight = '15px';
    }

    return box;
  },
  innerSection: {
    padding: '10px',
    margin: '10px',
    backgroundColor: '#F4F4F4'
  },
  map: (noPrescription) => {
    return {
      height: noPrescription ? '97%' : '48%',
      width: '100%',
      marginTop: '10px'
    }
  },
  prescription: (url) => {
    return {
      height: '48%',
      marginTop: '5px',
      cursor: 'pointer',
      display: 'flex',
      color: 'black',
      fontSize: '50px',
      fontWeight: 'bold',
      alignItems: 'center',
      justifyContent: 'center',
      filter: 'opacity(25%)',
      backgroundColor: '#F4F4F4',
      backgroundSize: 'cover',
      backgroundImage: `url(${url})`,
    };
  }
};

/**
 *
 * @param {object} props
 * @returns {XML}
 * @constructor
 */
const MissionView = (props) => {
  let { mission, className, style , activityList, togglePrescriptionDialog, deleteReport, toggleReportPreviewDialog} = props;
  return (
    <div className={className || 'mission__view'} style={{...styles.root, ...style}}>
      <h1 style={gStyles.header}>Mission</h1>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">

          <MissionBasicInfo
            mission={mission}
            style={styles.innerSection}
            className='mission__basic__info' />

          <PatientInfo
            mission={mission}
            style={styles.innerSection}
            className='patient__basic__info' />

          <DoctorInfo
            mission={mission}
            style={styles.innerSection}
            className='doctor__basic__info' />
          {
            mission.followups.length > 0 &&
            <FollowupInfo
              mission={mission}
              style={styles.innerSection}
              className='doctor__basic__info' />
          }

          {
            mission.reviews.length > 0 &&
            <ReviewListView
              reviews={mission.reviews}
              style={styles.innerSection}
              className='mission__reviews' />
          }

          {/*<ActionButtons*/}
            {/*mission={mission}*/}
            {/*endMission={endMission}*/}
            {/*reopenMission={reopenMission}/>*/}

        </div>

        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-md m-b-15">
          {
            mission.prescription &&
            <PrescriptionList
                prescriptionList={mission.prescription}
                displayPrescriptionDialog={togglePrescriptionDialog}
            />
          }
          <ReportList
            reportList={mission.investigation_reports}
            showReport={toggleReportPreviewDialog}
            deleteReport={deleteReport}
          />
          <ActivityList
            showMeta={true}
            activityList={activityList}
          />
        </div>
      </div>
    </div>
  );
};

export default MissionView;


// WEBPACK FOOTER //
// ./src/screens/mission-view/index.js